var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobbliIconChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7912 14.4598C34.7583 23.7817 27.2153 31.3143 17.9463 31.2816C8.67727 31.2489 1.18764 23.6633 1.22051 14.3414C1.22709 12.4774 2.73603 10.9706 4.58949 10.9771C6.44294 10.9836 7.94122 12.5011 7.93465 14.3651C7.91492 19.9589 12.408 24.5096 17.9701 24.5292C23.5323 24.5488 28.0573 20.03 28.077 14.4362C28.0836 12.5722 29.5926 11.0653 31.446 11.0718C33.2995 11.0784 34.7977 12.5958 34.7912 14.4598Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4574 7.9516C33.4305 7.95856 35.0357 6.35557 35.0427 4.37122C35.0497 2.38687 33.4559 0.772607 31.4828 0.765648C29.5097 0.758689 27.9045 2.36167 27.8975 4.34602C27.8905 6.33037 29.4843 7.94464 31.4574 7.9516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60002 7.85688C6.57312 7.86384 8.17832 6.26085 8.18531 4.2765C8.19231 2.29216 6.59847 0.67788 4.62536 0.670921C2.65225 0.663963 1.04706 2.26696 1.04006 4.2513C1.03306 6.23565 2.62691 7.84992 4.60002 7.85688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobbliIconChatbot);
export default __webpack_public_path__ + "static/media/jobbli-icon-chatbot.a2216a44a12563a10d5a92e5aa1cb262.svg";
export { ForwardRef as ReactComponent };